import styled from "styled-components";

export const ContainerElevation = styled.div`
	margin: -25px 15px 25px 15px;
	border-radius: 5px;
	background: var(--color-gray-bluish);
	padding: 5px 50px 15px 50px;

	@media (max-width: 959px) {
		padding: 5px 25px 15px 25px;
	}
`;

export const ButtonStep = styled.button`
	width: 140px;
	height: 35px;
	display: flex;
	justify-content: center;
	margin: 25px 0px 8px 20px !important;
	border: 1px solid var(--color-blue-younect) !important;
	border-radius: 5px;
	font-family: "Roboto", sans-serif !important;
	font-size: 14px;
	font-weight: bold;
	text-transform: uppercase;
	text-align: center !important;
	outline: none;
`;

export const ButtonStepOutlined = styled.button`
	width: 140px;
	height: 35px;
	margin: 25px 0px 8px 0px !important;
	border: 1px solid var(--color-blue-younect) !important;
	border-radius: 5px;
	font-family: "Roboto", sans-serif !important;
	font-size: 14px;
	font-weight: bold;
	text-transform: uppercase;
	outline: none;
	color: var(--color-blue-younect);

	&:hover {
		background: var(--color-blue-younect);
		color: var(--color-white);
	}
`;
